import {
  SHOW_TRACKED_LINK_CREATE_MODAL,
  HIDE_TRACKED_LINK_CREATE_MODAL,
  SHOW_ANALYTICS_MODAL,
  HIDE_ANALYTICS_MODAL
} from '../actions'

const initialState = {
  trackedModalPayload: {
    site: null
  },
  analyticsModalPayload: {
    analyticsType: null,
    site: null,
  }
}

const modalsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_TRACKED_LINK_CREATE_MODAL:
      return {
        ...state,
        trackedModalPayload: {
          site: action.payload.site
        }
      }
    case HIDE_TRACKED_LINK_CREATE_MODAL:
      return {
        ...state,
        trackedModalPayload: {
          site: null
        }
      }
    case SHOW_ANALYTICS_MODAL:
      return {
        ...state,
        analyticsModalPayload: {
          analyticsType: action.payload.analyticsType,
          site: action.payload.site,
        }
      }
    case HIDE_ANALYTICS_MODAL:
      return {
        ...state,
        analyticsModalPayload: {
          analyticsType: null,
          site: null,
        }
      }
    default:
      return state
  }
}

export default modalsReducer
